module.exports = __webpack_public_path__ + "static/media/error-svg.b2138751.svg";